<style lang="sass">
Table
  text-align: center
.top
  margin: 30px auto
.pages
  margin: 30px auto
</style>
<template>
    <Card>
        <div class="search-div" v-if="false">
            <Input class="input-div" placeholder="请输入名称搜索" clearable v-model="searchObj.name" ></Input>
            <Input class="input-div" placeholder="请输入上级名称搜索" clearable v-model="searchObj.top_name" ></Input>
            <Select placeholder="请选择状态搜索"  clearable class="input-div" v-model="searchObj.pay_status" >
                <Option v-for="(item, index) in searchObjArr.pay_status" :value="item.id" :key="index">{{item.val}}</Option>
            </Select>
            <Input class="input-div" placeholder="请输入合同编号搜索" clearable v-model="searchObj.contract_id" ></Input>
            <Select placeholder="请选择是否分账"  clearable class="input-div" v-model="searchObj.is_share" >
                <Option v-for="(item, index) in searchObjArr.is_share" :value="item.id" :key="index">{{item.val}}</Option>
            </Select>

            <Select placeholder="请选择收款类型"  clearable class="input-div" v-model="searchObj.type" >
                <Option value="1">抵押收费</Option>
                <Option value="2">解押收费</Option>
            </Select>

            <DatePicker class="input-div" type="datetimerange" @on-change='selectT' format="yyyy-MM-dd HH:mm" placeholder="请选择时间搜索" style="width: 300px"></DatePicker>

            <Input class="input-div" placeholder="请输入账号搜索" clearable v-model="searchObj.mobile" ></Input>
            <Input class="input-div" placeholder="请输入订单编号搜索" clearable v-model="searchObj.order_sn" ></Input>

            <Button type="primary" @click="searchItem">搜索</Button>
        </div>
        <div class="top">
            <!-- <Button type="success" :disabled="buttonList.addDisabled" @click="addData(1)" style="margin-right:8px;">添加</Button>
            <Button type="primary" :disabled="buttonList.editDisabled" @click="addData(2)" style="margin-right:8px;">修改</Button> -->
            <Button type="error" @click="todelData" :disabled="buttonList.delDisabled">删除</Button>
           <Button style="margin-left: 15px;" type="primary" @click="exportOrder">导出</Button>
             <!-- <Button type="primary" @click="exportData">导出</Button> -->
        </div>
         <Table :columns="titleName" :data="tableList.tableData" @on-sort-change="sortCustom" ref="selection" @on-selection-change="selectChange" ></Table>
          <Page @on-change="changePage" @on-page-size-change="changeSize" :total="page.total" show-sizer :show-total="true" :current="page.current" :page-size="page.pageSize" :age-size-opts="[10,20,30,50]" placement="top" class="pages"/>
          <!-- 编辑 / 添加  模态框组件 -->
           <ModelBox :showModel.sync="addBox.showModel" :fn="addBox.callbackFn" :type="type" :editFormData="addBox.editFormData"></ModelBox>
           <StatusModel :showModel.sync="statusBox.showModel" :fn="statusBox.callbackFn" :editFormData="statusBox.editFormData"></StatusModel>
        <!-- 删除弹框组件 -->
        <DeleteDialog ref="deleteChild" @ievent = "ievent"></DeleteDialog>
      
    </Card>
</template>
<script>
import Side from '../common/side.vue'
import common from '@/common/common.js';
import ModelBox from './addModel';
import StatusModel from './statusModel';
import moment from 'moment';
import DeleteDialog from '../common/deleteModel.vue'; // 引入删除弹框组件

    export default {
        name: "merchantAdmin",
        components: {
            ModelBox,
            DeleteDialog,
            StatusModel
        },
        data(){
            return{
                selectChangeData: [],
                loading: true,
                type:1,//弹框打开类型 1添加 2编辑
                tableList:{//表格组
                    hasSelectData:{},//已选中的行的数据
                    tableData: []//表格数据
                },
                statusBox:{
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                addBox:{//规格弹框组
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                },
                buttonList:{//按钮组
                    addDisabled:false,//添加按钮是否禁用
                    editDisabled:true,//编辑按钮是否禁用
                    delDisabled:true,//删除按钮是否禁用
                },
                page:{//分页排序
                    total:0,//总条数
                    pageSize:20,//每页条数
                    current:1,//当前页
                    key:'created_at',
                    order:'desc'
                },
                Pitem:"",
                searchObjArr:{ },
                searchObj:{  },
                titleName: [
                    { //多选框
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },

                    {
                        title: '订单商品',
                        key: 'order_good_name',
                        minWidth: 180
                    },
                    {
                        title: '订单状态',
                        key: 'status',
                        minWidth: 100,
                        render: (h, params) => {
                            let describe = {'1': '待发货', '2': '已发货', '3': '已完成', '4': '已退货'}
                            return h('span', {}, describe[params.row.status] )
                        }
                    },
                    {
                        title: '商品数量',
                        key: 'good_num',
                        minWidth: 100
                    },
                    {
                        title: '订单积分',
                        key: 'order_points',
                        minWidth: 100
                    },
                    {
                        title: '收货人',
                        key: 'consignee',
                        minWidth: 100
                    },
                    {
                        title: '身份证号',
                        key: 'consignee',
                        minWidth: 180,
                        render: (h, params) => {
                            return h('span', {}, params.row.profile.card_number)
                        }
                    },
                    {
                        title: '收货人手机',
                        key: 'mobile',
                        minWidth: 150
                    },
                    {
                        title: '地区',
                        key: 'area',
                        minWidth: 180,
                        render: (h, params) => {
                            return h('span', {}, params.row.profile.province+ params.row.profile.city+ params.row.profile.area)
                        }
                    },
                    {
                        title: '详细地址',
                        key: 'address',
                        minWidth: 150,
                        render: (h, params) => {
                            return h('span', {}, params.row.profile.address)
                        }
                    },
                    {
                        title: '创建时间',
                        key: "created_at",
                        sortable: 'custom',
                        minWidth: 180
                    },
                    {
					  title: '操作',
					  minWidth:120,
                      key: "id",
                      fixed:'right',
					  render: (h, params) => {
					        return h('Button', {
					            props: {
                                    type: "primary",
                                    size: 'small'
                                },
					            on: {
					                click: () => { this.changeStatus(params.row) }
					            }
					        },"设置")
					    }
					},
                ],
            }
        },
        created() {
            this.getData();
        },
        methods: {
          exportOrder() { //导出
            let toekn = common.getToken()
            let searchObj = this.searchObj
            let parHtml = ''
            for (let key in searchObj) {
                if (Array.isArray(searchObj[key])) {
                // parHtml+=`&${key}=${JSON.stringify(searchObj[key])}`
                parHtml += `&${key}=${searchObj[key].join(',')}`
                } else {
                parHtml += `&${key}=${searchObj[key]}`
                }
            }
            let urls = `${this.config.urlArray.systemOrderExport}?token=${toekn}${parHtml}`
            window.open(urls);
            },
            selectT(val){
                console.log(val)
                this.searchObj.loan_time = val
                this.searchObj.loan_time = val.join(',')
            },
            todelData() {
                this.$refs.deleteChild.showit();
            },
            // 批量删除
            ievent() {
                let getData = {
                    id: this.tableList.hasSelectData.id,
                }
                this.axios.post(this.config.urlArray.orderDestroy, getData).then((result)=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.clearbtnStatus();
                        this.$refs.deleteChild.recancel();
                        this.getData();
                    })
                }).catch((err)=>{
                    common.msg('error','删除失败')
                })
            },
            searchItem(){
                this.getData()
            },
            getData() {//获取数据
                let getData = {
                    params: {
                        page: this.page.current,
                        pagesize: this.page.pageSize,
                        sortfield: this.page.key,
                        ascDesc: this.page.order
                    }
                }
                Object.assign(getData.params,this.searchObj)
                this.axios.get(this.config.urlArray.orderShow, getData).then((result) => {
                    common.ajaxMsg(result.data);
                    let resData = result.data.data.list
                    //处理数组
                    this.tableList.tableData = resData
                    this.page.total = result.data.data.paging.total
                    this.loading = false
                }).catch((err) => {
                    common.msg('error','获取失败',()=>{})
                });
            },
            sortCustom(data) {//自定义排序
                this.page.key = data.key
                this.page.order = data.order
                this.getData()
            },
            changeStatus(item) {  
                this.statusBox.showModel = true
                this.statusBox.editFormData = item
                
                this.statusBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.statusBox.showModel = false;
                    this.getData();
                }
            },
            addData(type) {  //添加或编辑数据
                this.addBox.showModel = true
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = this.tableList.hasSelectData
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.clearbtnStatus()
                    this.addBox.showModel = false;
                    this.getData();
                }
            },
            selectChange(res) { //控制编辑和删除按钮的可用状态
                this.selectChangeData = res
                if(res.length == 1){
                    this.buttonList.editDisabled = this.buttonList.delDisabled = false
                    this.tableList.hasSelectData = res[0]
                }else{
                    this.buttonList.editDisabled = this.buttonList.delDisabled = true
                    this.tableList.hasSelectData = {}
                }
            },
            changePage(nowpage) {//切换分页
                this.page.current = nowpage;
                this.getData();
            },
            changeSize(nowSize) {//切换每页显示条数
                this.page.pageSize = nowSize
                this.page.current = 1
                this.getData()
            },
            clearbtnStatus() { //删除后清空编辑数据 与按钮状态
                this.buttonList.delDisabled = true
                this.buttonList.editDisabled = true
                this.addBox.editFormData ={}
                this.tableList.hasSelectData = {}
            },
        }
    }
</script>
